import { IChangePackSorting, PackActionTypes } from "../models/packActions";
import { CHANGE_PACK_SORTING } from "../types";

export default (data: IChangePackSorting["payload"]): PackActionTypes => ({
    type: CHANGE_PACK_SORTING,
    payload: data,
});
